<template>
  <div class="index">
    <div>
      <div class="max-w">
        <div class="banner-warp flex">
          <catalogListVue></catalogListVue>
          <div class="banners">
            <div class="top">
              <swiper ref="bannerSwiper" v-bind:options="bannerOptions" v-if="bannerFinsh">
                <swiper-slide
                  v-for="(item, index) in bannerList"
                  v-bind:key="'banner' + index"
                  class="banner"
                  :class="{ 'cursor-pointer': item.linkUrl }"
                >
                  <div @click="item.linkUrl ? routeTo(item.linkUrl) : ''">
                    <img :src="item.pcImg" :alt="item.title" />
                  </div>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
              <div class="swiper-button-prev-custom">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next-custom">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="bottom flex">
              <a
                :href="pointShopUrl"
                class="shop-link"
                target="_blank"
                :style="{ backgroundImage: 'url(' + require('@/assets/images/pointBanner.png') + ')' }"
                @click.capture="hinaClickPointShop(1)"
              >
              </a>
              <router-link
                to="/brand"
                class="shop-link"
                :style="{ backgroundImage: 'url(' + require('@/assets/images/brandBanner.png') + ')' }"
                @click.native="hinaBrandClick"
              >
              </router-link>

              <!-- <a :href="pointShopUrl + '/point/sale/'" class="shop-link" target="_blank" :style="{
                backgroundImage:
                  'url(https://download.zhidiancloud.com/mro/images/20240318/2cade350-c472-4582-acab-9abfd070b25b.png)',
              }" @click.capture="hinaActivityClick">
            </a> -->
              <activitySwiper
                v-if="activityList?.length"
                class="shop-link"
                :activityImgs="activityList"
                @goActivityDetail="goActivityDetail"
              >
              </activitySwiper>
            </div>
          </div>

          <div class="user-warp flex">
            <div class="user-info">
              <div class="user-text" v-if="userStore.nickName">
                <router-link to="/usercenter/infomanagement" class="user-name flex">
                  <p>{{ userStore.nickName }}</p>
                  <i class="el-icon-arrow-right"></i>
                </router-link>
                <p class="enterpriseName">{{ userStore.enterpriseName }}</p>
                <p class="point">
                  积分：<span class="font-bold">{{ score }}</span>
                  <el-link :href="pointShopUrl" type="primary" target="_blank">去兑换</el-link>
                </p>
                <p class="level" v-if="userStore.levelName">会员：{{ userStore.levelName }}</p>
              </div>
              <div class="user-text-unLogin" v-else>
                <p class="hello">Hi~欢迎光临智电云商！</p>
                <div>
                  <el-button size="" type="primary" @click="routeTo('/login')">登录</el-button>
                  <el-button size="" @click="routeTo('/register')">注册</el-button>
                </div>
              </div>
            </div>
            <div class="quickLink">
              <div class="flex" @click="toShoppingCart">
                <span>
                  <i class="mro MRO-gouwuche-kong"></i>
                  <p>我的购物车</p>
                </span>
              </div>
              <div class="flex" @click="routeTo('/favorites')">
                <span>
                  <i class="mro MRO-shoucang"></i>
                  <p>我的收藏</p>
                </span>
              </div>
              <div class="flex" @click="routeTo('/usercenter/order')">
                <span>
                  <i class="mro MRO-dianzipiao"></i>
                  <p>全部订单</p>
                </span>
              </div>
              <div class="flex" @click="routeTo('https://work.weixin.qq.com/kfid/kfc8aaed7d6d8e7f4fb')">
                <span>
                  <i class="mro MRO-kefu"></i>
                  <p>联系客服</p>
                </span>
              </div>
              <div
                class="flex"
                @click="routeTo('/usercenter/sourcing')"
                v-if="appStores.isInner && !appStores.isHideMoney"
              >
                <span>
                  <i class="mro MRO-xunyuan"></i>
                  <p>我的寻源</p>
                </span>
              </div>
              <div class="flex" @click="routeTo('/usercenter/bargain')">
                <span>
                  <i class="mro MRO-xunjia"></i>
                  <p>我的询价</p>
                </span>
              </div>
            </div>
            <div class="sourcing-warp">
              <p>{{ appStores.isInner ? '没有找到想要的产品？' : '已经有BOM配单？' }}</p>
              <el-button type="primary" size="mini" @click="routeTo('/product/sourcing')"
                >发起{{ appStores.isInner ? '寻源' : '配单' }}</el-button
              >
            </div>
          </div>
        </div>
        <!-- 分类 -->
        <SemiconductorCate v-if="appStores.isShopHost"></SemiconductorCate>
      </div>

      <CompanyModule v-if="appStores.isShopHost" />
      <div class="max-w">
        <div class="big-title">热门推荐</div>
        <div class="popular-warp">
          <el-tabs v-model="popularActive" @tab-click="changePopular" stretch>
            <el-tab-pane
              v-for="(item, index) in popular"
              :key="'popular' + index"
              :label="item.name"
              :name="item.id + ''"
            ></el-tab-pane>
          </el-tabs>
          <div class="popularList">
            <swiper ref="popularSwiper" v-bind:options="popularOptions">
              <swiper-slide v-for="(item, index) in popularActiveList" v-bind:key="'popular' + item.name + index">
                <indexProductVue
                  :showPromotionActivityFlag="false"
                  show-activity-name
                  :data="item"
                  :show-all="false"
                  :show-brand="true"
                  padding="0"
                  @click.native="hinaHotRecommendClick(item)"
                />
              </swiper-slide>
            </swiper>
            <div class="swiper-button-prev-custom">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div class="swiper-button-next-custom">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="max-w">
        <div class="big-title">新品推荐</div>
        <div class="newproduct-warp">
          <div v-for="(item, index) in newProduct" :key="'new-product' + index">
            <indexProductVue
              :data="item"
              :show-all="false"
              :show-brand="false"
              tag="新品"
              show-activity-name
              text-align="center"
              backgroud-color="#F5F7FA"
              money-size="18px"
              :showPromotionActivityFlag="false"
              @click.native="hinaNewRecommendClick(item)"
            />
          </div>
          <div ref="loadMoreRef"></div>
        </div>
        <div class="package-warp flex" v-if="packageList.length > 0">
          <div class="left">
            <div class="big-title">套餐推荐</div>
            <div class="flex">
              <indexPackage
                v-for="item in packageList.slice(0, 2)"
                :key="item.id"
                :data="item"
                @packageClick="hinaPackageClick(item)"
              ></indexPackage>
            </div>
          </div>
          <div class="right">
            <div class="big-title-more text-right">
              <router-link to="/packages/list" @click.native="hinaClickMorePackage"
                >更多推荐 <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
            <div class="in-package" v-if="packageList[2]">
              <indexPackage size="small" :data="packageList[2]" @packageClick="hinaPackageClick(packageList[2])">
              </indexPackage>
            </div>
            <div v-else class="h-260px w-260px"></div>
          </div>
        </div>

        <div class="big-title">为你推荐</div>
        <div class="recommend-warp">
          <div v-for="(item, index) in recommendList" :key="'recommend-product' + index">
            <indexProductVue
              :data="item"
              :show-all="false"
              :show-brand="true"
              :shadow="true"
              showPriceDescTitle
              @click.native="hinaRecommendClick(item)"
            />
          </div>
          <div ref="loadMoreRef"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {
  getBanner,
  getBannerRestful,
  userInnerRecommeds,
  userSopRecommends,
  sopRecommends,
  getSopList,
  getInnerList,
  getPopularRecommend,
  getINPopularRecommend,
  getRecommendPackage,
  getRecommendPackageInner,
  innerAutoRecommeds,
  getRestInnerList,
} from '@/api/product';
import { getPoints } from '@/api/points';
import catalogListVue from '@/layout/components/catalogList.vue';
import { userInfo } from '@/stores/userInfo';
import { appInfo } from '@/stores/appInfo';
import { productInfo } from '@/stores/productInfo';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import indexProductVue from '@/views/components/indexProduct.vue';
import indexPackage from '@/views/components/indexPackage.vue';
import 'swiper/swiper-bundle.css';
import { useElementVisibility } from '@vueuse/core';
import * as hinaApi from '@/utils/hina';
import _ from 'lodash';
import { useSeoMeta } from '@unhead/vue';
import activitySwiper from '@/views/components/home/activitySwiper.vue';
import useActivityList from '@/composables/activity/useActivityList';
import CompanyModule from './components/home/companyModule.vue';
import SemiconductorCate from './components/home/semiconductorCate.vue';

const appStores = appInfo();
const page = ref({ pageNum: 1, pageSize: 10, total: 0, first: true, stopLoad: false });
const userStore = userInfo();
const productStore = productInfo();
const bannerFinsh = ref(false);
const bannerList = ref([]);
const bannerOptions = ref({});
const recommendList = ref([]);
const loadMoreRef = ref();
const loadMoreRefIsVisible = useElementVisibility(loadMoreRef);
const score = ref(0);
const newProduct = ref([]);
const popular = ref([]);
const popularActive = ref('');
const popularActiveList = ref([]);
const popularOptions = ref({
  autoHeight: true,
  slidesPerView: 5,
  spaceBetween: 20,
  navigation: {
    nextEl: '.popularList .swiper-button-next-custom',
    prevEl: '.popularList .swiper-button-prev-custom',
  },
});
const packageList = ref([]);
console.log('是否缓存: ', 1);
const router = useRouter();
const pointShopUrl = import.meta.env.VITE_APP_DOMAIN_POINT;
watch(
  () => loadMoreRefIsVisible.value,
  val => {
    if (val && !page.value.stopLoad) {
      loadRecommend();
    }
  },
  {
    immediate: true,
  }
);
const { getActivityList, activityList, goActivityDetail } = useActivityList('index');
function init() {
  //获取轮播
  loadBanner();
  //获取积分
  points();
  //新品推荐
  loadNewProduct();
  //热门推荐
  loadPopular();
  // 套餐推荐
  loadIndexPick();
  getActivityList();
  page.value.first = true;
}

function loadIndexPick() {
  if (appStores.isInner) {
    getRecommendPackageInner({ pageNum: 1, pageSize: 3, hostId: userStore.defaultHostId }).then(res => {
      packageList.value = res.rows;
    });
  } else {
    getRecommendPackage({ pageNum: 1, pageSize: 3 }).then(res => {
      packageList.value = res.rows;
    });
  }
}
function loadPopular() {
  if (userStore.token && appStores.isSmallCompanyHost) {
    getINPopularRecommend({ hostId: userStore.defaultHostId }).then(res => {
      popular.value = res.data;
      if (res.data.length > 0) {
        popularActive.value = popular.value[0].id + '';
        changePopular({ name: popularActive.value });
      }
    });
  } else {
    getPopularRecommend({ hostId: appStores.isSmallCompanyHost ? userStore.defaultHostId : 1 }).then(res => {
      popular.value = res.data;
      if (res.data.length > 0) {
        popularActive.value = popular.value[0].id + '';
        changePopular({ name: popularActive.value });
      }
    });
  }
}
function points() {
  if (userStore.nickName) {
    getPoints().then(res => {
      score.value = res.data?.points ?? 0;
    });
  }
}

function loadNewProduct() {
  if (appStores.isSmallCompanyHost && userStore.token) {
    getInnerList({ hostId: userStore.defaultHostId }).then(res => {
      newProduct.value = res.data;
    });
  } else if (appStores.isSmallCompanyHost && !userStore.token) {
    getRestInnerList({ hostId: userStore.defaultHostId }).then(res => {
      newProduct.value = res.data;
    });
  } else {
    getSopList().then(res => {
      newProduct.value = res.data;
    });
  }
}

function loadBanner() {
  bannerFinsh.value = false;
  getBannerRestful({ hostId: appStores.isSmallCompanyHost ? userStore.defaultHostId : 1 }).then(res => {
    setBanner(res.rows);
  });
}
function setBanner(data) {
  bannerList.value = data;
  bannerOptions.value = {
    loop: bannerList.value.length > 1,
    autoplay: bannerList.value.length > 1,
    autoHeight: true,
    // 显示分页
    pagination: {
      el: '.banners .swiper-pagination',
      clickable: true, //允许分页点击跳转
    },
    navigation: {
      nextEl: '.banners .swiper-button-next-custom',
      prevEl: '.banners .swiper-button-prev-custom',
    },
  };
  bannerFinsh.value = true;
}

function loadRecommend() {
  if (page.value.first) {
    page.value.pageNum = 1;
    page.value.total = 0;
    recommendList.value = [];
  }
  if (recommendList.value.length < page.value.total || page.value.first) {
    page.value.first = false;

    if (userStore.nickName) {
      if (appStores.isSmallCompanyHost) {
        userInnerRecommeds({ ...page.value, hostId: userStore.defaultHostId }).then(res => {
          setRecommend(res);
        });
      } else {
        userSopRecommends(page.value).then(res => {
          setRecommend(res);
        });
      }
    } else {
      if (appStores.isSmallCompanyHost) {
        innerAutoRecommeds({ ...page.value, hostId: userStore.defaultHostId }).then(res => {
          setRecommend(res);
        });
      } else {
        sopRecommends(page.value).then(res => {
          setRecommend(res);
        });
      }
    }
  }
}
function setRecommend(res) {
  page.value.total = res.total;
  recommendList.value = recommendList.value.concat(res.rows);
  page.value.pageNum++;
  if (recommendList.value.length >= page.value.total) {
    page.value.stopLoad = true;
  }
}
function routeTo(url) {
  if (url) {
    if (url.indexOf('http') !== -1) {
      window.open(url);
    } else {
      useRouter().push({
        path: url,
      });
    }
  }
}
function handleQuickLink(item) {
  checkLogin().then(() => {
    useRouter().push({ name: item.name });
  });
}
function changePopular(e) {
  console.log(popular.value, e);
  let data = popular.value.find(item => item.id == e.name);
  console.log(data);
  popularActiveList.value = data?.productVos;
}

function toShoppingCart() {
  hinaApi.headerCartClickPoint({
    inlet: 2,
  });
  useRouter().push('/shoppingcart');
}

function hinaClickPointShop(point_inlet) {
  hinaApi.homePointEnterPoint({
    point_inlet,
  });
}
// 活动点击埋点
function hinaActivityClick() {
  hinaApi.activeClickEnter({
    active_inlet: 1,
  });
}

// 热门推荐埋点 hinaHotRecommendClick
function hinaHotRecommendClick(product) {
  const curCateInfo = popular.value.find(item => item.id == popularActive.value);
  hinaApi.homeHotRecommendPoint({
    product_id: product.id,
    product_name: product.name,
    product_price: product.price,
    cate_id: curCateInfo.id,
    cate_name: curCateInfo.name,
  });
}

// 新品推荐埋点 hinaNewRecommendClick
function hinaNewRecommendClick(product) {
  hinaApi.homeNewRecommendPoint({
    product_id: product.id,
    product_name: product.name,
    product_price: product.price,
  });
}

// 首页为你推荐埋点 hinaRecommendClick
function hinaRecommendClick(product) {
  hinaApi.homeRecommendPoint({
    product_id: product.id,
    product_name: product.name,
    product_price: product.price,
  });
}

// 套餐点击入口
function hinaPackageClick(packageInfo) {
  hinaApi.homePackageClickPoint({
    package_id: packageInfo.id,
    package_name: packageInfo.name,
    package_inlet: 1,
  });
  // alert(packageInfo);
}

// 首页品牌入口点击 hinaBrandClick
function hinaBrandClick() {
  hinaApi.enterBrandClickPoint({
    brand_inlet: 1,
  });
}

// 首页点击套餐显示更多
function hinaClickMorePackage() {
  hinaApi.enterPackgaeListPoint({
    package_list_inlet: 1,
  });
}

init();

useSeoMeta({
  title: () => `${appStores.seoShopName} - 企业MRO，供应链数字化，一站式工业品采购平台`,
  keywords: () =>
    `${
      appStores.seoShopName
    }是一家专业的互联网工业品采购平台,致力于为企业生产运营提供所需的生产物资、各种辅料和易耗品，统一寻源供应，提供一站式的供应链服务，主营商品已覆盖${productStore.mainCategory.join()}等${
      productStore.mainCategory.length
    }大品类，帮助客户持续降低工业用品的采购和管理成本，通过“数字化的管理工具和物联网技术”帮助中小企业快速完成数字化转型。`,
  description: () =>
    `${appStores.seoShopName}（${location.host}）工业超市，mro电商平台，工业品一站式采购平台，mro工业品采购平台，工业品电商平台，mro工业品商城，工业品，场景化采购，询比价`,
  ogUrl: () => location.href,
});
</script>
<style lang="scss" scoped>
.index {
  background: $main-backgroud-color;

  .big-title {
    font-weight: bold;
    font-size: 20px;
    padding: 40px 0 8px;
  }

  .big-title-more {
    font-size: 14px;
    padding: 46px 0 8px;
  }

  .banner-warp {
    align-items: stretch;
    height: 472px;
    padding-top: 16px;

    .banners {
      margin: 0 16px;
      overflow: hidden;
      width: 768px;
      position: relative;

      .top {
        background: #fff;
        border-radius: 6px;
        overflow: hidden;
        height: 336px;
        position: relative;

        .swiper-container {
          .banner {
            img {
              display: block;
              max-width: 100%;
              width: 100%;
            }
          }

          .cursor-pointer {
            cursor: pointer;
          }

          ::v-deep .swiper-pagination {
            .swiper-pagination-bullet {
              background: #fff;
              border-radius: 4px;
              transition: all 0.5s;
            }

            .swiper-pagination-bullet-active {
              width: 30px;
              background: $main-color;
            }
          }
        }

        .swiper-button-prev-custom,
        .swiper-button-next-custom {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 50px;
          background: rgba(0, 0, 0, 0.2);
          position: absolute;
          top: calc(50% - 20px);
          z-index: 1;
          cursor: pointer;
          color: #fff;
        }

        .swiper-button-prev-custom {
          left: 0;
        }

        .swiper-button-next-custom {
          right: 0;
        }
      }

      .bottom {
        margin-top: 16px;
        gap: 0 16px;

        .shop-link {
          background: #fff center no-repeat;
          background-size: cover;
          border-radius: 6px;
          height: 120px;
          overflow: hidden;
          display: block;
          flex: 1;
        }
      }
    }

    .user-warp {
      width: 200px;
      flex-shrink: 0;
      flex-direction: column;
      align-items: normal;

      .user-info {
        background: url('@/assets/images/index-user-bg.png') no-repeat center center;
        background-size: cover;
        padding: 24px;
        flex-shrink: 0;
        height: 136px;
        border-radius: 6px;
        box-sizing: border-box;

        .user-text {
          .user-name {
            font-size: 14px;
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .enterpriseName {
            margin-top: 6px;
            font-size: 12px;
            color: #909399;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .point,
          .level {
            color: #333333;
            font-size: 12px;
          }

          .point {
            margin-top: 16px;

            .el-link {
              font-size: 12px;
            }

            span {
              color: $main-color;
              margin-right: 8px;
            }
          }

          .level {
            margin-top: 6px;
          }
        }

        .user-text-unLogin {
          .hello {
            font-size: 14px;
            line-height: 22px;
            text-align: center;
            color: #333333;
            margin: 8px 0 16px;
          }

          .el-button {
            padding: 9px 12px;
            width: calc((100% - 10px) / 2);
          }
        }
      }

      .quickLink {
        margin-top: 16px;
        padding: 14px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 12px;
        overflow: auto;
        flex-grow: 1;
        background-color: #fff;
        border-radius: 6px;

        div {
          text-align: center;
          border-radius: 3px;
          font-size: 12px;
          padding: 6px 5px;
          cursor: pointer;

          span {
            width: 100%;
          }

          i {
            color: $main-color;
            font-size: 26px;
          }

          p {
            margin: 0;
            margin-top: 8px;
          }

          &:hover {
            p {
              color: $main-color;
            }
          }
        }
      }

      .sourcing-warp {
        background: url('@/assets/images/index-sourcing-bg.png') no-repeat center center;
        background-size: cover;
        padding: 10px 18px;
        flex-shrink: 0;
        color: #fff;
        border-radius: 0 0 6px 6px;

        p {
          margin: 0 0 10px;
        }
      }
    }
  }

  .newproduct-warp {
    padding: 20px;
    background-color: #fff;
    border-radius: 6px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: 16px;
  }

  .popular-warp {
    padding: 0 20px;
    background-color: #fff;
    border-radius: 6px;

    ::v-deep .el-tabs {
      .el-tabs__nav-scroll {
        padding: 0 200px;

        .el-tabs__item {
          font-size: 16px;
          height: auto;
          margin: 8px 0;
        }
      }
    }

    .popularList {
      padding: 0 36px 16px;
      position: relative;

      .swiper-button-prev-custom,
      .swiper-button-next-custom {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 48px;
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        top: calc(50% - 20px);
        z-index: 1;
        cursor: pointer;
        color: #fff;
        border-radius: 6px;
      }

      .swiper-button-prev-custom {
        left: 0;
      }

      .swiper-button-next-custom {
        right: 0;
      }
    }
  }

  .package-warp {
    .left {
      width: 924px;

      .flex {
        .package-box {
          flex-grow: 0;
          width: 454px;
        }
      }
    }

    .right {
      width: 260px;
    }
  }

  .recommend-warp {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 16px;
    padding-bottom: 40px;
  }
}
</style>

<route>
    {
        meta: {
        keepAlive: true
    }
    }
    </route>
